module.exports = __webpack_public_path__ + "img/question_blue.fd310f0c.svg";